import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  class: "font-weight-bold",
  "data-test-ref": "multi-factor-auth-code-verification-heading"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-not-entered-icon"
}, null, -1 /* HOISTED */)
const _hoisted_5 = {
  class: "mb-0",
  "data-test-ref": "multi-factor-auth-code-not-entered-text"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-expired-icon"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-new-code-error-icon"
}, null, -1 /* HOISTED */)
const _hoisted_8 = {
  class: "mb-0",
  "data-test-ref": "multi-factor-auth-code-new-code-error-text"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-system-error-icon"
}, null, -1 /* HOISTED */)
const _hoisted_10 = {
  class: "mb-0",
  "data-test-ref": "multi-factor-auth-code-system-error-text"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle mr-2",
  "data-test-ref": "multi-factor-auth-code-success-get-new-code-icon"
}, null, -1 /* HOISTED */)
const _hoisted_12 = {
  class: "mb-0",
  "data-test-ref": "multi-factor-auth-code-success-get-new-code-text"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle icon-circle mr-2",
  "data-test-ref": "multi-factor-auth-code-account-locked-error-icon"
}, null, -1 /* HOISTED */)
const _hoisted_14 = {
  class: "mb-0",
  "data-test-ref": "multi-factor-auth-code-account-locked-error-text"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { "data-test-ref": "multi-factor-auth-code-enter-code-label" }
const _hoisted_17 = {
  class: "font-weight-bold",
  "data-test-ref": "multi-factor-auth-code-not-receive-code-heading"
}
const _hoisted_18 = {
  class: "d-flex align-items-center",
  "data-test-ref": "multi-factor-auth-code-might-take-few-minutes"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { "data-test-ref": "multi-factor-auth-code-divider" }, null, -1 /* HOISTED */)
const _hoisted_20 = {
  class: "d-flex justify-content-end mt-4 mb-4",
  "data-test-ref": "multi-factor-auth-buttons"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-right",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-continue-icon"
}, null, -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-triangle-exclamation mr-3",
  "data-test-ref": "multi-factor-auth-code-session-expired-icon"
}, null, -1 /* HOISTED */)
const _hoisted_23 = {
  class: "mt-3",
  "data-test-ref": "multi-factor-auth-code-session-expired-text"
}
const _hoisted_24 = {
  class: "border-bottom pb-5",
  "data-test-ref": "multi-factor-auth-code-session-expired-keep-you-safe"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle mr-2",
  "aria-hidden": "true",
  "data-test-ref": "multi-factor-auth-code-account-locked-icon"
}, null, -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", { "data-test-ref": "multi-factor-auth-code-account-locked-divider" }, null, -1 /* HOISTED */)

import { useI18n } from '@/i18n';
import { formatPhoneNumber } from '@/utils/format';
import { useRouter } from 'vue-router';
import { useAppStore, useMultiFactorAuthStore } from '@/store';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';

import MultiFactorAuthNavInterupt from '@/components/mfa/multi-factor-auth-nav-interupt.vue';

import { computed, onMounted, reactive, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, minLength, maxLength } from '@vuelidate/validators';
import { OneTimePasswordRequest } from '@/types/mfa';
import { createMemberMfaService } from '@/composables/multi-factor-auth-service';
import { MultiFactorStatusCode } from '@/enums/multi-factor-auth';
import { AxiosError } from 'axios';
import { onBeforeRouteLeave } from 'vue-router';
import { deviceInfoService } from '@/composables/device-info-service';
import { getSecureAemSiteIdentifier } from '@/utils/aem';


export default /*#__PURE__*/_defineComponent({
  __name: 'multi-factor-auth-code',
  setup(__props) {

const validationRules = {
    code: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)

    }
};
const nonSecureService = useNonsecureService();
const ledsService = useLedsService();
const memberMfaService = createMemberMfaService({
    nonsecureService: nonSecureService,
    ledsService: ledsService
});
const appStore = useAppStore();
const { t } = useI18n();
const router = useRouter();
const phoneNumber = t('mfa.faq.phoneNumber');
const formattedPhoneNumber = computed(() => formatPhoneNumber(phoneNumber));
const memberOneTimePassword = reactive({
    code: ''
});
const v$ = useVuelidate(validationRules, memberOneTimePassword);

const loading = ref<boolean>(false);
const isValidated = ref<boolean>(false);
const isCodeEmpty = ref<boolean>(false);
const isNewCodeSent = ref<boolean>(false);
const isNewCodeSentError = ref<boolean>(false);
const isAccountLocked = ref<boolean>(false);
const isFocused = ref<boolean>(false);
const isCodeExpired = ref<boolean>(false);
const isCodeInCorrect = ref<boolean>(false);
const isSystemError = ref<boolean>(false);
const isMfaTokenExpired = ref<boolean>(false);
const canActiveToContactChannels = ref<boolean>(false);
const showFaqModal = ref<boolean>(false);
const selectedMultiFactorAuth = ref<string>('');
const multiFactorAuthStore = useMultiFactorAuthStore();

onMounted(() => {
    selectedMultiFactorAuth.value = multiFactorAuthStore.selectedContactChannel?.displayText ?? '';
});

onBeforeRouteLeave((to, from, next) => {
    showFaqModal.value = true;
    next(canActiveToContactChannels.value);
});

const navigateToLogin = () => {
    window.location.href = appStore.logoutUrl ?? '';
};

const navigateToMfaOptions = () => {
    canActiveToContactChannels.value = true;
    router.push({
        name: 'multi-factor-auth-contact-channels',
    });
};

const isMemberOneTimePasswordValid = async() => {
    const isValidLength = await v$.value.$validate();
    return isValidLength;
};

const onCodeEnter = () => {
    const value = memberOneTimePassword.code.replace(/\s+/g, '');
    if (value.length >= 1) {
        isValidated.value = false;
        isCodeEmpty.value = false;
    }
};

const resetFlags = () => {
    isValidated.value = false;
    isNewCodeSent.value = false;
    isNewCodeSentError.value = false;
    isAccountLocked.value = false;
    isCodeInCorrect.value = false;
    isCodeExpired.value = false;
    isSystemError.value = false;
    isCodeEmpty.value = false;
    isMfaTokenExpired.value = false;
};

const handleContinue = async () => {
    resetFlags();
    const validationResult = await isMemberOneTimePasswordValid();
    if (!validationResult) {
        isCodeEmpty.value = true;
        isValidated.value = true;
        return;
    }
    isCodeEmpty.value = false;
    try {
        loading.value = true;
        const deviceInfo = await deviceInfoService.getDeviceInfo();
        const mfaToken = multiFactorAuthStore.multifactorAuthToken ?? '';
        const payload: OneTimePasswordRequest = {
            oneTimePassword: memberOneTimePassword.code,
            mfaToken: mfaToken,
            deviceInfo
        };
        const response = await memberMfaService.validateOneTimePassword({
            payload,
            signal: new AbortController().signal,
        });
        const { status, data } = response;

        const queryParams = new URLSearchParams();
        const site = getSecureAemSiteIdentifier();
        if (site) {
            // If site isn't passed, Instil theme will flash blue for a split second.
            queryParams.append('site', site);
        }

        if (status === MultiFactorStatusCode.MULTIFACTOR_SUCCESS) {
            const { authToken } = data;
            queryParams.append('authToken', authToken ?? '');
            const redirectUrl = `https://${window.location.hostname}/site-router.html?${queryParams.toString()}`;
            window.location.href = redirectUrl;
        } else if (status === MultiFactorStatusCode.MULTIFACTOR_REDIRECT_PASSWORD_INTERRUPT) {
            const { updatePasswordToken } = data;
            queryParams.append('updatePasswordToken', updatePasswordToken ?? '');
            const redirectUrl = `https://${window.location.hostname}/site-router.html?${queryParams.toString()}`;
            window.location.href = redirectUrl;
        }
    } catch (axiosError) {
        const errorCode = (axiosError as AxiosError)?.response?.status;
        if (errorCode === MultiFactorStatusCode.MULTIFACTOR_OTP_EXPIRED) {
            isCodeExpired.value = true;
            isValidated.value = true;
            logger.error('error code' + errorCode);
        } else if (errorCode === MultiFactorStatusCode.MULTIFACTOR_INVALID_OTP) {
            isCodeInCorrect.value = true;
            isValidated.value = true;
            logger.error('error code' + errorCode);
        } else if (errorCode === MultiFactorStatusCode.MULTIFACTOR_LOCKED) {
            isAccountLocked.value = true;
            logger.error('error code' + errorCode);
        } else if (errorCode === MultiFactorStatusCode.MULTIFACTOR_MFA_TOKEN_EXPIRED) {
            isMfaTokenExpired.value = true;
            logger.error('error code' + errorCode);
        } else if (errorCode === MultiFactorStatusCode.MULTIFACTOR_SESSION_TIMEOUT) {
            isMfaTokenExpired.value = true;
            logger.error('error code' + errorCode);
        } else {
            isSystemError.value = true;
            isValidated.value = true;
            logger.error('error code' + errorCode);
        }
    } finally {
        loading.value = false;
    }
};

const requestNewAccessCode = async () => {
    loading.value = true;
    const channelId: string = multiFactorAuthStore.selectedContactChannel?.channelId ?? '';
    resetFlags();
    try {
        const deviceInfo = await deviceInfoService.getDeviceInfo();
        const mfaToken = multiFactorAuthStore.multifactorAuthToken ?? '';
        const payload = {
            channelId: channelId,
            deviceInfo
        };
        const mfaResponse = await memberMfaService.requestMemberOneTimePassword({
            signal: new AbortController().signal,
            mfaToken: mfaToken,
            payload: payload
        });
        if (mfaResponse.data.mfaToken) multiFactorAuthStore.setMultifactorAuthToken(mfaResponse.data.mfaToken);
        logger.log(mfaResponse, 'mfaResponse');
        isNewCodeSent.value = true;
    } catch (error) {
        isNewCodeSentError.value = true;
    } finally {
        loading.value = false;
        memberOneTimePassword.code = '';
    }
};

const leavePage = () => {
    canActiveToContactChannels.value = true;
    showFaqModal.value = false;
    router.push({
        name: 'multi-factor-auth-contact-channels',
    });
};

const stayOnPage = () => {
    canActiveToContactChannels.value = false;
    showFaqModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    show: loading.value,
    variant: "light",
    opacity: "0.75",
    rounded: "sm",
    class: "mt-2",
    "spinner-variant": "primary",
    "data-test-ref": "multi-factor-auth-code-overlay"
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" Main content when account is NOT locked "),
      (!(isAccountLocked.value || isMfaTokenExpired.value))
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            action: "javascript:void(0)",
            onSubmit: _withModifiers(handleContinue, ["prevent"])
          }, [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('mfa.title.codeHeading')), 1 /* TEXT */),
            _createElementVNode("p", {
              class: "text-muted",
              "data-test-ref": "multi-factor-auth-code-receive-info",
              innerHTML: _unref(t)('mfa.message.codeRecieveInfo', { selectedMultiFactorAuth: selectedMultiFactorAuth.value })
            }, null, 8 /* PROPS */, _hoisted_3),
            (isCodeEmpty.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 0,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-not-entered-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('mfa.error.codeEmptyError')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (isCodeExpired.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 1,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-expired-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_i18n_t, {
                      keypath: "mfa.error.codeExpiredError",
                      tag: "p",
                      scope: "global",
                      class: "m-0",
                      "data-test-ref": "multi-factor-auth-code-expired-text"
                    }, {
                      newCode: _withCtx(() => [
                        _createVNode(_component_b_link, {
                          class: "text-primary fw-semibold",
                          "data-test-ref": "multi-factor-auth-code-new-code-link",
                          onClick: requestNewAccessCode
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('mfa.message.newCode')), 1 /* TEXT */)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ]),
                      tryAnother: _withCtx(() => [
                        _createVNode(_component_b_link, {
                          class: "text-primary fw-semibold",
                          "data-test-ref": "multi-factor-auth-code-try-another-link",
                          onClick: navigateToMfaOptions
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('mfa.message.tryAnother')), 1 /* TEXT */)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (isNewCodeSentError.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 2,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-new-code-error-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('mfa.error.newCodeError')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (isSystemError.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 3,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-system-error-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('mfa.error.systemErrorForCodeEntry')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (isNewCodeSent.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 4,
                  show: "",
                  variant: "success",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-success-get-new-code-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('mfa.success.successGetNewCode')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (isCodeInCorrect.value)
              ? (_openBlock(), _createBlock(_component_b_alert, {
                  key: 5,
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-account-locked-error-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('mfa.error.codeIncorrectError')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createElementVNode("p", {
              class: "text-muted",
              "data-test-ref": "multi-factor-auth-code-disclaimer",
              innerHTML: _unref(t)('mfa.message.codeDisclaimer')
            }, null, 8 /* PROPS */, _hoisted_15),
            _createVNode(_component_b_form_group, { "data-test-ref": "multi-factor-auth-code-form-group" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("label", _hoisted_16, null, 512 /* NEED_PATCH */), [
                  [_directive_t, 'mfa.label.enterCode']
                ]),
                _createVNode(_component_b_form_input, {
                  modelValue: memberOneTimePassword.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((memberOneTimePassword.code) = $event)),
                  type: "text",
                  maxlength: "6",
                  class: _normalizeClass(["wc-10", {
                        'is-invalid': isValidated.value,
                        'is-valid': memberOneTimePassword.code.length === 6 && !isValidated.value,
                        'default-focus': isFocused.value
                    }]),
                  autocomplete: "false",
                  "data-test-ref": "multi-factor-auth-code-enter-code-input",
                  onInput: onCodeEnter
                }, null, 8 /* PROPS */, ["modelValue", "class"])
              ], undefined, true),
              _: 1 /* STABLE */
            }),
            _createElementVNode("h2", _hoisted_17, _toDisplayString(_unref(t)('mfa.title.notReceiveCode')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_i18n_t, {
                keypath: "mfa.message.codeMightTakeFewMinutes",
                tag: "p",
                scope: "global",
                "data-test-ref": "multi-factor-auth-code-might-take-few-minutes-text"
              }, {
                newCode: _withCtx(() => [
                  _createVNode(_component_b_link, {
                    "data-test-ref": "multi-factor-auth-code-new-code-link",
                    onClick: requestNewAccessCode
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('mfa.message.newCode')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ]),
                tryAnother: _withCtx(() => [
                  _createVNode(_component_b_link, {
                    "data-test-ref": "multi-factor-auth-code-try-another-link",
                    onClick: navigateToMfaOptions
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('mfa.message.tryAnother')), 1 /* TEXT */)
                    ], undefined, true),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_b_button, {
                variant: "outline-primary mr-2",
                "data-test-ref": "multi-factor-auth-code-back-button",
                onClick: navigateToMfaOptions
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('mfa.action.back')), 1 /* TEXT */)
                ], undefined, true),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_b_button, {
                type: "submit",
                variant: "primary",
                "data-test-ref": "multi-factor-auth-code-continue-button",
                disabled: isSystemError.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('mfa.action.continue')) + " ", 1 /* TEXT */),
                  _hoisted_21
                ], undefined, true),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ])
          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1))
        : (isMfaTokenExpired.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Content when mfa token is expired "),
              _createVNode(_component_b_alert, {
                show: "",
                variant: "warning",
                "data-test-ref": "multi-factor-auth-code-session-expied-alert",
                class: "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(t)('mfa.error.sessionExpired')), 1 /* TEXT */)
                ], undefined, true),
                _: 1 /* STABLE */
              }),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(t)('mfa.warning.keepYourDataSafe')), 1 /* TEXT */)
            ], 64 /* STABLE_FRAGMENT */))
          : (isAccountLocked.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createCommentVNode(" Content when account IS locked "),
                _createVNode(_component_b_alert, {
                  show: "",
                  variant: "danger",
                  class: "d-flex align-items-center",
                  "data-test-ref": "multi-factor-auth-code-account-locked"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _createVNode(_component_i18n_t, {
                      keypath: "mfa.error.mfaAccountLocked",
                      tag: "span",
                      scope: "global",
                      "data-test-ref": "multi-factor-auth-code-account-locked-text"
                    }, {
                      phoneNumber: _withCtx(() => [
                        _createVNode(_component_b_link, {
                          class: "text-primary",
                          "data-test-ref": "multi-factor-auth-code-phone-number"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(formattedPhoneNumber)), 1 /* TEXT */)
                          ], undefined, true),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ], undefined, true),
                  _: 1 /* STABLE */
                }),
                _hoisted_26,
                _createVNode(_component_b_row, {
                  class: "d-flex justify-content-end mt-4 mb-4",
                  "data-test-ref": "multi-factor-auth-code-buttons"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_button, {
                      variant: "outline-primary mr-2",
                      "data-test-ref": "multi-factor-auth-code-back-button",
                      onClick: navigateToLogin
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('mfa.action.returnToLogIn')), 1 /* TEXT */)
                      ], undefined, true),
                      _: 1 /* STABLE */
                    })
                  ], undefined, true),
                  _: 1 /* STABLE */
                })
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
      _createVNode(MultiFactorAuthNavInterupt, {
        id: "navigationInterruptModal",
        modelValue: showFaqModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showFaqModal).value = $event)),
        onLeavePage: leavePage,
        onStayOnPage: stayOnPage
      }, null, 8 /* PROPS */, ["modelValue"])
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}
}

})